
import Layout from "@/components/layout/Layout";
import ProfileGenerator from "@/components/toolkit/ProfileGenerator";
import ToolkitPageWrapper from "@/components/toolkit/ToolkitPageWrapper";
import { WifiOff } from "lucide-react";
import { Button } from "@/components/ui/button";

const ProfileGeneratorPage = () => {
  return (
    <Layout 
      title="Profile Overview Generator | Freelance With Andy"
      description="Generate professional freelance profile overviews with AI assistance that stand out on platforms like Upwork and Fiverr"
      keywords="profile generator, freelance profile, upwork profile, fiverr profile, freelance success, andy nady, professional profile, AI profile writer"
      path="/freelance-toolkit/profile-generator"
    >
      <ToolkitPageWrapper
        title="Professional Profile Overview Generator"
        description="Create a compelling, professionally formatted profile overview for freelance platforms in seconds. Our AI writer helps you stand out with properly structured, visually appealing profiles that highlight your skills and experience."
        toolName="Profile Overview Generator tool"
        redirectUrl="/freelance-toolkit/profile-generator"
        errorFallback={
          <div className="bg-white rounded-lg shadow-sm p-8 text-center">
            <div className="flex items-center justify-center mb-4">
              <WifiOff className="h-8 w-8 text-red-500 mr-2" />
              <h2 className="text-2xl font-bold">Network Connection Error</h2>
            </div>
            <p className="text-muted-foreground mb-6">
              We're having trouble connecting to our AI services to generate your profile overview.
              This could be due to:
            </p>
            <ul className="text-left text-muted-foreground mb-6 max-w-md mx-auto space-y-2 list-disc pl-6">
              <li>Your internet connection being unstable</li>
              <li>A temporary outage with our AI services</li>
              <li>A VPN or firewall blocking the connection</li>
              <li>High traffic on our AI services</li>
            </ul>
            <p className="text-sm text-muted-foreground mb-6">
              Please try again in a few minutes when our services are less busy or your internet connection is more stable.
            </p>
            <Button 
              onClick={() => window.location.reload()}
              className="px-6"
            >
              Reload Page
            </Button>
          </div>
        }
      >
        <div className="mb-8 max-w-3xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            <div className="bg-muted/20 p-4 rounded-lg border border-muted/30">
              <h3 className="text-lg font-medium mb-2">Professional Format</h3>
              <p className="text-sm text-muted-foreground">
                Generate profiles with proper sections, emojis, and professional formatting that stands out on freelance platforms.
              </p>
            </div>
            <div className="bg-muted/20 p-4 rounded-lg border border-muted/30">
              <h3 className="text-lg font-medium mb-2">Client-Focused Content</h3>
              <p className="text-sm text-muted-foreground">
                Our AI emphasizes your value to clients rather than just listing skills, helping you win more proposals.
              </p>
            </div>
            <div className="bg-muted/20 p-4 rounded-lg border border-muted/30">
              <h3 className="text-lg font-medium mb-2">Copy & Download</h3>
              <p className="text-sm text-muted-foreground">
                Easily copy your new profile to use immediately or download it for future reference and editing.
              </p>
            </div>
          </div>
        </div>

        <ProfileGenerator />
      </ToolkitPageWrapper>
    </Layout>
  );
};

export default ProfileGeneratorPage;
